<div class="container">
  @if (shouldBeIndented()) {
    <div class="indentation"></div>
  }

  <div [formGroup]="formGroup()" class="criteria-item">
    <div class="row row-content">
      <div class="fields" [class.view-mode]="isReadOnly()">
        <div class="item">
          <app-input-select
            emitRawValue
            [enableViewMode]="isReadOnly()"
            class="large no-padding-bottom"
            [options]="propertyOptions()"
            [placeholder]="translations.property"
            [copyMode]="copyMode()"
            formControlName="path"
          ></app-input-select>
        </div>
        <div class="item">
          <app-input-select
            emitRawValue
            [enableViewMode]="isReadOnly()"
            class="large no-padding-bottom"
            [options]="operatorOptions()"
            [placeholder]="translations.operator"
            [copyMode]="copyMode()"
            formControlName="operator"
          ></app-input-select>
        </div>
        <div class="item">
          @if (isEqOperator()) {
            <app-input-select
              emitRawValue
              formControlName="value"
              [enableViewMode]="isReadOnly()"
              class="large no-padding-bottom"
              [options]="valueComponentOptions().options"
              [placeholder]="translations.value"
              [viewModeTemplate]="valueComponentOptions().viewModeTemplate"
              [prefixTemplate]="flag"
            ></app-input-select>
          } @else {
            <app-input-chips
              class="no-padding-bottom tags-container-no-padding-top"
              formControlName="value"
              [enableViewMode]="isReadOnly()"
              (tagCreatedEvent)="
                valueComponentOptions().tagCreatedEvent
                  ? valueComponentOptions().tagCreatedEvent($event)
                  : null
              "
              [allowCreateTag]="valueComponentOptions().allowCreateTag"
              [tagUrl]="valueComponentOptions().tagUrl"
              [options]="valueComponentOptions().options"
              [placeholder]="translations.value"
              [viewModeTemplate]="valueComponentOptions().viewModeTemplate"
            ></app-input-chips>
          }
        </div>
      </div>
      <div class="flex gap-col-20">
        @if (shouldDisplayOptions()) {
          <app-button type="icon" class="large" [matMenuTriggerFor]="moreOptionsMenu">
            <mat-icon>more_vert</mat-icon>
          </app-button>
          <app-button
            type="icon"
            class="large"
            [tp]="translations.deleteCriteria"
            (pressed)="onRemove()"
          >
            <mat-icon>delete</mat-icon>
          </app-button>
        }
      </div>
    </div>
  </div>
</div>

@if (booleanOperator()) {
  <div class="boolean-operator">
    {{ booleanOperatorText() | uppercase }}
  </div>
}

<ng-template #countryViewTemplate let-countryTags let-label="label">
  @let tags = isArray(countryTags) ? countryTags : [countryTags];

  <div class="tags-container flex-wrap">
    @for (country of tags; track country.value) {
      <app-tag [tag]="{ label: country.label }">
        <app-flag [country]="country.value.toString()"></app-flag>
      </app-tag>
    }
  </div>
</ng-template>

<ng-template #flag let-option>
  <app-flag [country]="option.value"></app-flag>
</ng-template>

<mat-menu #moreOptionsMenu yPosition="above" class="dropdown-menu">
  <app-dropdown-menu>
    <app-dropdown-menu-item (pressed)="convertToGroup.emit()">
      <ng-container i18n="@@action.converttocriteriagroup">Convert to criteria group</ng-container>
    </app-dropdown-menu-item>
  </app-dropdown-menu>
</mat-menu>
